import { render, staticRenderFns } from "./NewParPriceModal.vue?vue&type=template&id=37997946&scoped=true"
import script from "./NewParPriceModal.vue?vue&type=script&lang=js"
export * from "./NewParPriceModal.vue?vue&type=script&lang=js"
import style0 from "./NewParPriceModal.vue?vue&type=style&index=0&id=37997946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37997946",
  null
  
)

export default component.exports